import { render, staticRenderFns } from "./storageGoodsDialog.vue?vue&type=template&id=58db8757&"
import script from "./storageGoodsDialog.vue?vue&type=script&lang=js&"
export * from "./storageGoodsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports